export enum TOAST_IDS {
  CutsCheckAlert = 'CutsCheckAlert',
  QualityAlert = 'QualityAlert',
  MinProductMissing = 'MinProductMissing',
  ProjectProductsNotUploaded = 'ProjectProductsNotUploaded',
  ErrorUploadingFiles = 'ErrorUploadingFiles',
  HappyCaseOrPhotokitCompleted = 'HappyCaseOrPhotokitCompleted',
}
